import {Component, OnInit} from '@angular/core';
import {ApiService} from '../../../shared/services/api.service';
import {Marketday} from '../../../entities';
import {ColumnMode, SelectionType, SortType} from '@swimlane/ngx-datatable';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {SendMarketwebsitePreviewComponent} from '../../../shared/send-marketwebsite-preview/send-marketwebsite-preview.component';
import { CUSTOM_SLUG } from '../../../app.constants';
import slugify from 'slugify';
import { JhiLanguageService } from 'ng-jhipster';

@Component({
  selector: 'app-marketwebsite-list',
  templateUrl: './marketwebsite-list.component.html',
  styles: []
})
export class MarketwebsiteListComponent implements OnInit {

  public rows: Marketday[] = [];
  public allRows: Marketday[] = [];
  public loading = false;

  public marketNameFilter: string;
  public branchFilter = 'Alle Niederlassungen';
  public statusFilter = 'Alle';

  branchOptions = ['Alle Niederlassungen'];
  statusOptions = ['Alle', 'Offline', 'Online'];

  sorting = [{prop: 'marketdayNumber', dir: 'asc'}];
  sortType: SortType = SortType.single;
  selectionType: SelectionType = SelectionType.single;
  columnMode: ColumnMode = ColumnMode.force;
  modalRef: NgbModalRef = null;

  constructor(
    public modalService: NgbModal,
    private apiService: ApiService,
    private jhiLanguageService: JhiLanguageService
  ) {
    this.jhiLanguageService.setLocations(['home']);
  }

  ngOnInit() {
    this.load().then();

  }

  async load(): Promise<void> {
    this.loading = true;
    const result = await this.apiService.find(Marketday, 'marketdays', {params: {size: 500}}).toPromise();
    result.forEach(item => {
      if (!this.rows.some(r => r.marketplace.id === item.marketplace.id)
        && item.branchString !== '10 - Eschenburg' && item.active === true) {
        this.rows.push(item);
        if (!this.branchOptions.find((branchOption) => branchOption === item.branchString ))  {
          this.branchOptions.push(item.branchString);
        }
      }
    });

    this.branchOptions.sort();
    this.allRows = [...this.rows];
    this.loading = false;
  }

  getUrl(md: Marketday) {
    slugify.extend(CUSTOM_SLUG);
    const city = slugify(md.marketplace.city);
    // let place = md.marketplace.place.trim();
    // city = this.replaceSpecialChars(city, false);
    // place = this.replaceSpecialChars(md.marketplace.place, false);
    // tslint:disable-next-line:max-line-length
    return `https://${city}.treffpunkt-wochenmarkt.de/${md.marketplace.marketplaceNumber}${!this.isInWeb(md) ? '?preview=true' : ''}`.toLowerCase();
  }

  isInWeb(md: Marketday): boolean {
    return !md.notInWeb && !md.marketwebsiteSince || !md.notInWeb && (new Date(md.marketwebsiteSince) <= new Date());
  }

  applyFilters() {
    this.rows = [...this.allRows];
    if (this.marketNameFilter && this.marketNameFilter !== '') {
      this.rows = this.rows.filter(
        row => {
          return row.marketplace.keyword.toUpperCase().includes(this.marketNameFilter.toUpperCase())
          || row.marketdayNumber.includes(this.marketNameFilter);
        }
      );
    }
    if (this.branchFilter && this.branchFilter !== 'Alle Niederlassungen') {
      this.rows = this.rows.filter(row => row.branchString === this.branchFilter);
    }
    if (this.statusFilter && this.statusFilter !== 'Alle') {
      this.rows = this.rows.filter(row => row.notInWeb === (this.statusFilter !== 'Online'));
    }
  }

  selectBranchFilter(branch: string) {
    this.branchFilter = branch;
  }
  selectStatusFilter(status: string) {
    this.statusFilter = status;
  }

  sortClick(event: any) {
    if (this.sortType === SortType.multi) {
      this.sortType = SortType.single;
      this.sorting = [{prop: event.column.prop, dir: event.newValue}];
    }
  }

  openSendPreviewModal(marketday: Marketday) {
    this.modalRef = this.modalService.open(SendMarketwebsitePreviewComponent, {size: 'lg'});
    this.modalRef.componentInstance.market = marketday;
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/components/marketwebsite-list/marketwebsite-list.component.ts